import React, { useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";
import VirtualizedListbox from "./VirtualizedListbox";

export default function AutocompleteEditCell({
  id,
  field,
  value,
  api,
  options,
  optionIdField,
  optionLabelField,
  multiple = false,
  label = "",
}) {
  const selectedOptions = useMemo(() => {
    if (!options?.length) return multiple ? [] : null;
    if (multiple) {
      const arrayOfIds = Array.isArray(value) ? value : [];
      return options.filter((opt) => arrayOfIds.includes(opt[optionIdField]));
    } else {
      return options.find((opt) => opt[optionIdField] === value) || null;
    }
  }, [value, options, optionIdField, multiple]);

  const handleChange = (event, newValue) => {
    let finalValue;
    if (multiple) {
      finalValue = Array.isArray(newValue)
        ? newValue.map((item) => item[optionIdField])
        : [];
    } else {
      finalValue = newValue ? newValue[optionIdField] : null;
    }

    api.setEditCellValue({ id, field, value: finalValue }, event);
  };

  return (
    <Autocomplete
      multiple={multiple}
      disableCloseOnSelect={multiple}
      options={options}
      value={selectedOptions}
      onChange={handleChange}
      isOptionEqualToValue={(option, val) =>
        option[optionIdField] === val[optionIdField]
      }
      getOptionLabel={(option) => option[optionLabelField]?.toString() ?? ""}
      ListboxComponent={VirtualizedListbox}
      renderInput={(params) => (
        <TextField {...params} size="small" label={label} />
      )}
      size="small"
      renderTags={(selected) =>
        multiple && selected.length > 0 ? [`${selected.length} selected`] : []
      }
      sx={{ display: "flex", alignItems: "center", width: "100%" }}
    />
  );
}
